import React from 'react';

import SvgIcon from '../SvgIcon';

const IconSignOut = (props: React.SVGAttributes<SVGSVGElement>) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M7 5V2c0-.552.398-1 .888-1h6.223c.49 0 .889.448.889 1v12c0 .552-.398 1-.89 1H7.889C7.398 15 7 14.552 7 14v-3m4-3H1m3-3L1 8l3 3"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default IconSignOut;
